import type {
  AggregateStatus,
  SubIBParams,
  SubIBStats,
  SubIBTableData,
} from "../types";

import { createReportContext } from "../../context/ReportContext";

const subIBReport = createReportContext(
  { statuses: "multi" as const, programs: "multi" as const },
  "SubIBReport",
)<
  { statuses: AggregateStatus; programs: string },
  { table: SubIBTableData; stats: SubIBStats },
  SubIBParams
>();

export const {
  Provider: BaseSubIBReportProvider,
  useReportContext: useBaseSubIBReportContext,
} = subIBReport;
